/* tslint:disable */

/**
 */
export class ChangeLabel {
    LABEL?: string;
    ID_TRANSLATION?: number;
    TRANS_TYPE?: number;
    CODE_LANGUE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/change-label.ts